jQuery(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >=100) {
        jQuery("body").addClass("lang-active");
    } else {
        jQuery("body").removeClass("lang-active");
    }
});
jQuery(document).ready(function() {
              var owl = jQuery('.category-slider');
              owl.owlCarousel({
                margin: 10,
                nav: true,
                loop: false,
                dots:false,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items: 4
                  }
                }
              })
              var owl = jQuery('.blog-slider');
              owl.owlCarousel({
                margin: 20,
                nav: true,
                loop: false,
                dots:false,
                responsive: {
                  0: {
                    items: 1
                  },
                  600: {
                    items: 2
                  },
                  1000: {
                    items: 3
                  }
                }
              })
               var owl = jQuery('.featured-items-slider');
              owl.owlCarousel({
                margin: 20,
                nav: true,
                loop: false,
                dots:false,
                autoHeight: true,
                items: 1
              })
            })
 
 jQuery(function(){

  //Scroll event
  jQuery(window).scroll(function(){
    var scrolled = jQuery(window).scrollTop();
    if (scrolled > 200) $('.go-top').fadeIn('slow');
    if (scrolled < 200) $('.go-top').fadeOut('slow');
  });
  
  //Click event
  jQuery('.go-top').click(function () {
    jQuery("html, body").animate({ scrollTop: "0" },  500);
  });

});
jQuery(document).ready(function(){
	jQuery('.nav-item-custom-tab').click(function(){
		// reset active class
		jQuery('.nav-item-custom-tab').removeClass("active");
		// add active class to selected
		jQuery(this).addClass("active");
		// return needed to make function work
		return false;
	});
	
	
	jQuery(function() {
		// create an empty variable
		var selectedClass = "";
		// call function when item is clicked
		jQuery(".nav-item-custom-tab").click(function(){
			// assigns class to selected item
			selectedClass = $(this).attr("data-rel");
			// fades out all brands-filter items
			jQuery(".brands-filter .brands-filter-content").fadeOut(0);
			// fades in selected category
			jQuery(".brands-filter .brands-filter-content." + selectedClass).fadeIn(0);
		});
	});
  
}); // document ready


  jQuery(document).ready(function(){
jQuery(function(jQuery) {
  let url = window.location.href;
  jQuery('.leran-tags-filetr ul li a').each(function() {
    if (this.href === url) {
      jQuery(this).closest('li').addClass('active');
    }
  });
   jQuery(".ar-load-row").slice(0, 6).show();
  jQuery("#loadMore").on("click", function(e){
    e.preventDefault();
    jQuery(".ar-load-row:hidden").slice(0, 6).slideDown();
    if(jQuery(".ar-load-row:hidden").length == 0) {
      jQuery("#loadMore").text("No More Posts").addClass("noContent");
    }
  });
  
   jQuery(".h-search-icon").click(function(){
    jQuery(".head-custom-search-bar").addClass("active-search");
  });
  jQuery(".hide-h-searh-btn").click(function(){
    jQuery(".head-custom-search-bar").removeClass("active-search");
  });
  
  jQuery(".categories-btn").click(function(){
    jQuery(".leran-tags-filetr").toggleClass("filter-active");
  });

});
        
  
            });

jQuery(document).ready(function(){
if (jQuery(window).width() < 991) {
jQuery(".brand-list-ul").click(function() {
  var is_open = jQuery(this).hasClass("open");
  if (is_open) {
    jQuery(this).removeClass("open");
  } else {
    jQuery(this).addClass("open");
  }
});

jQuery(".brand-list-ul li").click(function() {

  var selected_value = jQuery(this).html();
  var first_li = jQuery(".brand-list .nav-pills li:first-child").html();

  jQuery(".brand-list-ul li:first-child").html(selected_value);
  jQuery(this).html(first_li);

});

jQuery(document).mouseup(function(event) {

  var target = event.target;
  var select = jQuery(".brand-list-ul");

  if (!select.is(target) && select.has(target).length === 0) {
    select.removeClass("open");
  }

});
}
});
jQuery(document).ready(function($) {
              $('.annonuncement-slider').owlCarousel({
                items: 1,
                autoplay: true,
                autoplayTimeout:4000,
                loop: true,
                margin: 10,
				nav:false,
				dots:false,
              });

            });

jQuery(document).ready(function(){
  jQuery(".h-search-icon").click(function(){
    jQuery(".weglot-container").addClass("hide-lang");
  });
  jQuery(".hide-h-searh-btn").click(function(){
    jQuery(".weglot-container").removeClass("hide-lang");
  });
});


